module.exports = __webpack_public_path__ + "static/media/CTLA_10-178w.a9be8d41.webp";